import React, { useState } from 'react';
import { Menu } from 'lucide-react';
import { Button } from '../Button';
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from '../Sheet';
export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className="sticky top-0 z-50 w-full bg-brand-white border-b border-brand-gray shadow-sm h-[60px] md:h-auto flex items-center" data-id="element-41">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between h-full py-3 md:py-4" data-id="element-42">
        {/* Logo Wordmark */}
        <a href="#" className="flex items-center gap-2" data-id="element-43">
          <span className="font-display font-bold text-xl md:text-2xl text-brand-navy tracking-tight" data-id="element-44">
            Deep Clean Cleaners
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-45">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-brand-navy hover:text-brand-aqua font-medium transition-colors" data-id="element-46">
              {link.name}
            </a>)}
          <Button className="bg-brand-aqua hover:bg-brand-aqua-dark text-white rounded-full px-6 font-semibold" data-id="element-47">
            Get a Quote
          </Button>
        </nav>

        {/* Mobile Nav (Hamburger) */}
        <div className="md:hidden flex items-center" data-id="element-48">
          <Sheet open={menuOpen} onOpenChange={setMenuOpen} data-id="element-49">
            <SheetTrigger asChild data-id="element-50">
              <Button variant="ghost" size="icon" className="text-brand-navy" data-id="element-51">
                <Menu className="h-6 w-6" data-id="element-52" />
                <span className="sr-only" data-id="element-53">Toggle menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="fixed inset-0 w-screen max-w-none h-[100dvh] border-0 p-0 bg-brand-white overflow-hidden flex flex-col items-center justify-center [&>button]:top-6 [&>button]:right-6 [&>button]:p-1" data-id="element-54">
              <SheetTitle className="sr-only" data-id="element-55">Navigation Menu</SheetTitle>
              <nav className="flex flex-col items-center gap-6 w-full px-6" data-id="element-56">
                {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMenuOpen(false)} className="flex items-center justify-center min-h-[44px] text-brand-navy hover:text-brand-aqua font-display font-semibold text-2xl transition-colors" data-id="element-57">
                    {link.name}
                  </a>)}
                <Button onClick={() => setMenuOpen(false)} className="bg-brand-aqua hover:bg-brand-aqua-dark text-white rounded-full w-full max-w-[280px] mt-6 h-12 text-lg font-semibold" data-id="element-58">
                  Get a Quote
                </Button>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>;
}